import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userList, userDelete } from "../../../../store/actions/authActions";
import { Popconfirm, message, Empty } from "antd";
import { MaskEmail } from "../../../../utils/helper";
import TableWrapper from "../../../../components/Tables";
import Pagination from "../../../../components/Pagination";

const UserIndex = () => {
  const [search, setsearch] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();

  const datauserList = useSelector((state) => state.userList);
  const { user, listsUser } = datauserList;

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  useEffect(() => {
    dispatch(userList(1, search));
    localStorage.removeItem("id_user");
  }, [dispatch]);

  useEffect(() => {
        if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
    if (!userInfo.permission.includes("user-read")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, []);

  const handleEdit = (id) => {
    localStorage.setItem("id_user", id);
    history.push("/user-edit");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(userList(1, search));
  };

  const tableHead = [
    { name: "No" },
    { name: "Name" },
    { name: "Email" },
    { name: "Role" },
    { name: "Action" },
  ];

  const tableBody = [
    { scope: "row" },
    { render: (item) => item.name },
    { render: (item) => <MaskEmail item={item} /> },
    { render: (item) => item.role },
    {
      render: (item) => (
        <div align="center">
          {userInfo.permission.find((e) => e === "user-edit") ? (
            <button
              onClick={() => handleEdit(item.id)}
              className="btn btn-warning btn-sm"
            >
              <i className="fa fa-pencil"></i> Edit{" "}
            </button>
          ) : null}

          {userInfo.permission.find((e) => e === "user-delete") ? (
            <Popconfirm
              title="Are you sure to delete this user?"
              onConfirm={() =>
                dispatch(userDelete(item.id)).then(() =>
                  dispatch(userList(1, search))
                )
              }
              onCancel={() => message.info("Canceled!")}
              okText="Yes"
              cancelText="No"
            >
              <button className="btn btn-danger btn-sm">
                <i className="fa fa-trash-o"></i> Delete{" "}
              </button>
            </Popconfirm>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>User</h3>
        </div>
      </div>
      <div className="clearfix"></div>
      <br />
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                  {userInfo.permission.find((e) => e === "user-create") ? (
                    <Link to={"/user-create"} className="btn btn-info btn-sm">
                      Create
                    </Link>
                  ) : null}
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12 form-group has-feedback">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By Name"
                    style={{ float: "right", width: "50%", textOverflow: "ellipsis", paddingRight: "33px" }}
                    onChange={(e) => setsearch(e.target.value)}
                  />
                  <button
                    className="fa fa-search form-control-feedback right btn btn-link"
                    style={{
                      height: "100%",
                      margin: "auto",
                      textDecoration: "none",
                    }}
                    aria-hidden="true"
                    onClick={(e) => handleSearch(e)}
                  ></button>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>

            <div className="x_content overflow-auto">
              <TableWrapper
                datas={listsUser}
                tableHead={tableHead}
                tableBody={tableBody}
              />
              <Pagination
                datas={user}
                listsData={userList}
                search={search}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserIndex;
